/** @format */

import React from 'react';
import handleError from './handle_error';
import handleInputError from './handle_input_error';
import {Input} from '@sttark/design-system';
import {Input as ShadInput} from '@/components/ui/input';
import {If} from 'frontier-utilities';

/**
 * Wrap an input with our input error handler
 * Meant to be as flexible and transparent as possible
 * Steps for usage.
 * <InputWithErrorHandler
 *    className="form-control"
 *    type="text"
 *    error={props.error}
 *    errorPath="company"
 *    value={props.company || ''}
 *    onChange={props.onInputChange.bind(this, 'user.company')}
 * />
 * Import this component and give it all the normal values you would for an input but also add
 * error - This is the error object that contains the messages for fields {'user_detail': { 'text_number' : {'_empty':'hey! do not leave me empty'}}}
 * errorPath - This will look for the error at that endpoint. So for user_detail text_number error, you would pass user_detail.text_number
 * -- ADITIONAL NOTE --
 * if desiring to render the newest DS form input pass the newsetDS prop until we are able to get rid of the onld form field
 */
export default handleError(
    handleInputError(function InputWithErrorHandler({
        className,
        hasError,
        errorMessage,
        onChangeValue,
        error,
        newestds,
        label,
        inputRef = null,
        ...inputProps
    }) {
        if (hasError) {
            if (className && className.length > 0) {
                className = className.split(' ');
            } else {
                className = [];
            }
            className.push('is-invalid');
            inputProps.className = className.join(' ');
        } else {
            inputProps.className = className;
        }

        if (inputProps.type === 'number') {
            // prevent wheel even from scrolling our numbers
            inputProps.onWheel = e => e.target.blur();
        }

        // Go ahead and just send the value, not the full event
        let onChange = onChangeValue
            ? ({target: {value}}) => onChangeValue(value)
            : inputProps.onChange;

        // get rid of one of these functions once the old input is removed
        let onChangeNewsetDS = onChangeValue ? value => onChangeValue(value) : inputProps.onChange;

        if (newestds) {
            return (
                <>
                    <Input
                        {...inputProps}
                        label={label}
                        error={error}
                        onChange={onChangeNewsetDS}
                        ref={inputRef}
                        placeholder={inputProps.placeholder}
                    />
                    <If condition={hasError}>
                        <p className="tw-font-sm tw-text-danger tw-mt-3">{errorMessage}</p>
                    </If>
                </>
            );
        }

        return (
            <>
                <ShadInput {...inputProps} ref={inputRef} onChange={onChange} />
                <If condition={hasError}>
                    <p className="tw-font-sm tw-text-danger tw-mt-3">{errorMessage}</p>
                </If>
            </>
        );
    })
);
